import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { Home } from "@/pages/Home";
import { Properties } from "@/pages/Properties";
import { Architecture } from "@/pages/Architecture";
import { InstantQuote } from "@/pages/InstantQuote";
import { BuildCostEstimate } from "@/pages/BuildCostEstimate";
import { ClientLogin } from "@/pages/ClientLogin";
import { ClientDashboard } from "@/pages/ClientDashboard";
import { AdminLogin } from "@/pages/AdminLogin";
import { AdminDashboard } from "@/pages/AdminDashboard";
import { AdminSetPassword } from "@/pages/AdminSetPassword";
import { AdminForgotPassword } from "@/pages/AdminForgotPassword";
import { LandlordLogin } from "@/pages/LandlordLogin";
import { LandlordDashboard } from "@/pages/LandlordDashboard";
import { LandlordValuation } from "@/pages/LandlordValuation";
import { LandlordServices } from "@/pages/LandlordServices";
import { LandlordStarterKit } from "@/pages/LandlordStarterKit";
import { AddListing } from "@/pages/AddListing";
import { ArchitectureLeadForm } from "@/pages/ArchitectureLeadForm";
import { LandlordLeadForm } from "@/pages/LandlordLeadForm";
import { TenancyAgreement } from "@/pages/TenancyAgreement";
import { Services } from "@/pages/Services";
import { About } from "@/pages/About";
import { Branches } from "@/pages/Branches";
import { Contact } from "@/pages/Contact";
import { Valuation } from "@/pages/Valuation";
import { EmployeeSetup } from "@/pages/EmployeeSetup";
import { EmployeeLogin } from "@/pages/EmployeeLogin";
import { EmployeeDashboard } from "@/pages/EmployeeDashboard";
import { PropertySearch } from "@/pages/PropertySearch";
import { PropertyDetails } from "@/pages/PropertyDetails";
import { SignIn } from "@/pages/SignIn";
import { Toaster } from "@/components/ui/sonner";
import { AreaPage } from "@/pages/AreaPage";
import { SeekerLogin } from "@/pages/SeekerLogin";
import { Blog } from "@/pages/Blog";
import { BlogPost } from "@/pages/BlogPost";
import { SignAgreement } from "@/pages/SignAgreement";

function AppContent() {
  const location = useLocation();
  
  // Check for sign query parameter - if present, render SignAgreement
  const searchParams = new URLSearchParams(location.search);
  const signToken = searchParams.get('sign');
  
  if (signToken) {
    return <SignAgreement token={signToken} />;
  }
  
  const hideHeader = location.pathname.startsWith('/admin') || location.pathname.startsWith('/sign/');
  
  return (
    <>
      {!hideHeader && <Header />}
      <main className={hideHeader ? '' : 'pt-20'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/find-property" element={<PropertySearch />} />
          <Route path="/property/:id" element={<PropertyDetails />} />
          <Route path="/architecture" element={<Architecture />} />
          <Route path="/architecture/quote" element={<InstantQuote />} />
          <Route path="/architecture/build-cost" element={<BuildCostEstimate />} />
          <Route path="/architecture/enquiry" element={<ArchitectureLeadForm />} />
          {/* Architecture Client Portal */}
          <Route path="/client/login" element={<ClientLogin />} />
          <Route path="/client/dashboard" element={<ClientDashboard />} />
          {/* Landlord Portal & Lead Forms */}
          <Route path="/landlord/login" element={<LandlordLogin />} />
          <Route path="/landlord/dashboard" element={<LandlordDashboard />} />
          <Route path="/landlord/add-listing" element={<AddListing />} />
          <Route path="/landlord/enquiry" element={<LandlordLeadForm />} />
          <Route path="/landlord/free-valuation" element={<LandlordValuation />} />
          <Route path="/landlord/services" element={<LandlordServices />} />
          <Route path="/landlord/starter-kit" element={<LandlordStarterKit />} />
          {/* Employee Portal */}
          <Route path="/employee/setup" element={<EmployeeSetup />} />
          <Route path="/employee/login" element={<EmployeeLogin />} />
          <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
          {/* Property Seeker Portal */}
          <Route path="/seeker/login" element={<SeekerLogin />} />
          {/* E-Signature Portal */}
          <Route path="/sign/:token" element={<SignAgreement />} />
          {/* Admin Portal */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/tenancy-agreement" element={<TenancyAgreement />} />
          <Route path="/admin/set-password" element={<AdminSetPassword />} />
          <Route path="/admin/reset-password" element={<AdminSetPassword />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/branches" element={<Branches />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/valuation" element={<Valuation />} />
              {/* Local Area Pages - SEO */}
              <Route path="/areas/harrow" element={<AreaPage areaSlug="harrow" />} />
              <Route path="/areas/pinner" element={<AreaPage areaSlug="pinner" />} />
              <Route path="/areas/wembley" element={<AreaPage areaSlug="wembley" />} />
              <Route path="/areas/kenton" element={<AreaPage areaSlug="kenton" />} />
              <Route path="/areas/stanmore" element={<AreaPage areaSlug="stanmore" />} />
              <Route path="/areas/edgware" element={<AreaPage areaSlug="edgware" />} />
              <Route path="/areas/queensbury" element={<AreaPage areaSlug="queensbury" />} />
              <Route path="/areas/kingsbury" element={<AreaPage areaSlug="kingsbury" />} />
              <Route path="/areas/burnt-oak" element={<AreaPage areaSlug="burnt-oak" />} />
              <Route path="/areas/colindale" element={<AreaPage areaSlug="colindale" />} />
              <Route path="/areas/hendon" element={<AreaPage areaSlug="hendon" />} />
              <Route path="/areas/ruislip" element={<AreaPage areaSlug="ruislip" />} />
              <Route path="/areas/northolt" element={<AreaPage areaSlug="northolt" />} />
              <Route path="/areas/eastcote" element={<AreaPage areaSlug="eastcote" />} />
              <Route path="/areas/north-wembley" element={<AreaPage areaSlug="north-wembley" />} />
            </Routes>
          </main>
          {!hideHeader && <Footer />}
          <FloatingWhatsApp />
          <Toaster />
        </>
      );
    }

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
